/// <reference path="../include.ts" />

namespace project_common {

	export enum Orientation {
		landscape = 'landscape',
		portrait = 'portrait',
	}
}
